import { Component, OnInit } from '@angular/core';

export interface RouteInfo {
  path: string;
  titlemenu: string;
  title: string;
  icon: string;
  class: string;
}

export const ROUTES: RouteInfo[] = [
  { path: '/pbc', titlemenu: 'PBC', title: 'Programas en beneficio de las comunidades - PBC', icon: 'nc-single-02', class: '' },
  { path: '/actos-modificatorios', titlemenu: 'Actos Modificatorios', title: 'Actos Modificatorios', icon: 'nc-single-copy-04', class: '' },
  { path: '/veredas', titlemenu: 'Veredas', title: 'Veredas', icon: 'nc-globe-2', class: '' },
  { path: '/reporte/pbc-reportes', titlemenu: 'Reportes PBC', title: 'Reportes PBC', icon: 'nc-chart-pie-36', class: '' },
  {
    path: '/reporte/pozo-sismica-report', titlemenu: 'Pozos/Sísmica por Cuenca', title:
      'Reporte de Pozos/Sísmica por Cuenca', icon: 'nc-chart-pie-36', class: ''
  },
  {
    path: '/reporte/pozo-depto-muni-report', titlemenu: 'Pozos por Departamentos/Municipios',
    title: 'Reporte de Pozos por Departamentos/Municipios', icon: 'nc-chart-pie-36', class: ''
  },
  {
    path: '/reporte/pozo-depto-muni-report', titlemenu: 'Pozos por Departamentos/Municipios',
    title: 'Reporte de Pozos por Departamentos/Municipios', icon: 'nc-chart-pie-36', class: ''
  }
];

@Component({
  moduleId: module.id,
  selector: 'sidebar-cmp',
  templateUrl: 'sidebar.component.html',
})

export class SidebarComponent implements OnInit {
  public menuItems: any[];
  ngOnInit() {
    this.menuItems = ROUTES.filter(menuItem => menuItem);
  }
}
